import styled from 'styled-components';
import { styleVariables } from '../../../common/constants';

const TermsOfUseRootElement = styled.div`
    width: 100%;
    background: #f2f2f2;
    padding-top: ${styleVariables.primitivesFontSizeFallbacks['6']};
    padding-bottom: ${styleVariables.primitivesFontSizeFallbacks['6']};
    .accordion-list {
        box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.1) inset;
        margin: 0 0 4px 0px;
        &.Mui-expanded {
            box-shadow:
                0px 0px 0px 1px rgba(204, 204, 204, 0.5) inset,
                0px -1px 0px 0px #666 inset;
            margin: 0 0 4px 0px;
        }
    }
    .FAQ-heading {
        margin-bottom: 20px;
    }
    .see-more-button {
        margin-top: 12px;
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        cursor: pointer;
        svg {
            margin-left: 9px;
        }
    }
    .accordion-heading {
        padding: 0;
        .MuiAccordionSummary-content {
            padding: 16px;
            justify-content: space-between;
            .MuiTypography-headline-smaller{
                padding-right:5px;
            }
            svg {
                transform: rotate(0deg);
            }
            &.Mui-expanded {
                svg {
                    transform: rotate(180deg);
                }
            }
        }
    }

    .accordion-content {
        padding: 0 16px 30px;
        p {
            color: ${styleVariables.primitivesColor.primary.black};
            a {
                color: ${styleVariables.primitivesColor.primary.black} !important;
            }
        }
    }
    .partner-list-box{
        display: flex;
        flex-flow: column wrap;
        height: 100em;
        gap: 20px;
        @media screen and (max-width: 568px) {
            height: auto;
        }
        .partner-list-col{
            display: flex;
            flex-direction: column;
            flex: 0 0 auto;
            width: 32%;
            -moz-box-sizing: border-box;
            box-sizing: border-box; 
            @media screen and (max-width: 991px) {
                width: 31%;
            }
            @media screen and (max-width: 568px) {
                width: 100%;
            }
            ul{
              li{
                padding-left: 0;
                border-bottom: 1px solid rgba(0, 0, 0, 0.1);
              }
            }
        }
    }
`;
export default TermsOfUseRootElement;
